import { Box, Button, Divider, Grid, Paper, Typography } from "@mui/material";
import DetailsTable from "./DetailsTable";
import usePopup from "../../../../../hooks/usePopup";
import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { getBilledDetailsForUser } from "../../Service";
import { BillResponseType, getbilledItemDetailsResponseType } from "../../type";
import { PaymentContext, PaymentContextType } from "../context/Listprovider";
import { PatientFullDetailsType } from "../../../../../PatientCare/PatientBooking/v2/types";
import { useFetchPatientDetailsByEMR } from "../../../../../PatientCare/hookv2/apiHooks";
import dayjs from "dayjs";

const AmountCard = ({
  setDetails,
  selectedBill,
}: {
  setDetails?: Dispatch<SetStateAction<PatientFullDetailsType | null>>;
  selectedBill?: BillResponseType[] | null;
  paymentTypeMode: "full" | "partial";
}) => {
  const { CustomModal } = usePopup();
  const [open, setOpen] = useState(false);
  const { setAmountDetails, setBalance } = useContext(
    PaymentContext,
  ) as PaymentContextType;
  const { billingId } = useParams();
  const [billedDetails, setBilledDetails] =
    useState<getbilledItemDetailsResponseType | null>(null);
  const queryParams = new URLSearchParams(location.search);
  const { encounterId } = useParams() as { encounterId: string };
  const { mutate: getbillDetails, isLoading: isBillLoading } = useMutation(
    getBilledDetailsForUser,
    {
      onSuccess: (data) => {
        setBilledDetails(data.response);
      },
    },
  );
  console.log("billedDetails", billedDetails);
  const normalizedBills = selectedBill ?? [];
  useEffect(() => {
    const emrNo = (queryParams.get("emrno") || "") as string;
    getPatientData({ emrNo, encounterId: parseInt(encounterId || "0") });
    if (!open) return;
    if (!normalizedBills.length) return;
    const billIds = normalizedBills.map((bill) => bill.billNo);
    getbillDetails({
      billId: billIds,
      insname: patientData?.insurancePatient?.insurance_name ?? "",
    });
  }, [billingId, getbillDetails, open, normalizedBills]);

  const [patientData, setPatientData] =
    useState<PatientFullDetailsType | null>();

  const { mutate: getPatientData } = useFetchPatientDetailsByEMR({
    onSuccess: (result) => {
      setPatientData(result.response);
      if (setDetails) {
        setDetails(result.response);
      }
    },
  });
  console.log("patientData", patientData);
  const amountDetails = billedDetails?.amountDetails;

  const doctors = selectedBill
    ? [...new Set(selectedBill.map((bill) => bill.doctorName))]
    : [patientData?.encounter?.doctorName || ""];
  const topDetails = [
    {
      label: doctors.length < 2 ? "Consulted Doctor" : "Consulted Doctors",
      value: selectedBill
        ? [...new Set(selectedBill.map((bill) => bill.doctorName))]
        : [patientData?.encounter?.doctorName || ""],
    },
    {
      label: "Visit Date",
      value:
        selectedBill && selectedBill.length > 0
          ? [
              ...new Set(
                selectedBill.map((bill) =>
                  dayjs(bill.date).format("DD-MM-YYYY"),
                ),
              ),
            ]
          : [
              dayjs(patientData?.encounter?.createdDate).format("DD-MM-YYYY") ||
                "",
            ],
    },
  ];

  const details = [
    {
      label: "Total Cpt Amount",
      value: Number(
        selectedBill
          ?.reduce((acc, bill) => acc + bill.totalCptAmount, 0)
          .toFixed(2) || "0",
      ),
    },
    {
      label: "Ins Amount",
      value: Number(
        selectedBill
          ?.reduce((acc, bill) => acc + bill.insuranceAmount, 0)
          .toFixed(2) || "0",
      ),
    },
    {
      label: "Total Pat Share",
      value: Number(
        selectedBill
          ?.reduce((acc, bill) => acc + bill.patientShareAmount, 0)
          .toFixed(2) || "0",
      ),
    },
    {
      label: "Ins Discount Amount",
      value: Number(
        selectedBill
          ?.reduce((acc, bill) => acc + bill.insDiscount, 0)
          .toFixed(2) || "0",
      ),
    },
    {
      label: "Priority Patient",
      value: amountDetails?.priorityPatient ? "yes" : "No",
    },

    {
      label: "Paid Amount",
      value: Number(
        selectedBill
          ?.reduce((acc, bill) => acc + bill.amountPayed, 0)
          .toFixed(2) || "0",
      ),
    },
    {
      label: "Discount Amount",
      value: selectedBill
        ? Number(
            selectedBill.reduce((acc, bill) => {
              const share = Number(bill.patientShareAmount || 0);
              const paid = Number(bill.amountPayed || 0);
              const bal = Number(bill.balanceAmount || 0);
              return acc + (share - (paid + bal));
            }, 0),
          ).toFixed(2)
        : "0.00",
    },
    {
      label: "Balance Amount",
      value: Number(
        selectedBill
          ?.reduce((acc, bill) => acc + bill.balanceAmount, 0)
          .toFixed(2) || "0",
      ),
    },
  ];

  useEffect(() => {
    if (!selectedBill || selectedBill.length === 0) return;
    console.log("selectedBill => ", selectedBill);
    const CurrentTotalPatShare = Number(
      selectedBill
        .reduce((acc, bill) => acc + (bill.balanceAmount || 0), 0)
        .toFixed(2),
    );
    const AllTimeTotalPatShare = selectedBill.reduce(
      (acc, bill) => acc + (bill.patientShareAmount || 0),
      0,
    );

    const billNos = selectedBill.map((bill) => bill.billNo);
    const amountPayed = selectedBill.reduce(
      (acc, bill) => acc + bill.amountPayed,
      0,
    );
    const encounterIds = [
      ...new Set(selectedBill.map((bill) => bill.encounterId)),
    ];
    const insAmount = selectedBill?.reduce(
      (acc, bill) => acc + bill.insuranceAmount,
      0,
    );
    const insDiscount = selectedBill?.reduce(
      (acc, bill) => acc + bill.insDiscount,
      0,
    );
    setAmountDetails({
      patShare: CurrentTotalPatShare,
      balanceAmount: CurrentTotalPatShare,
      billNo: billNos.join(", "),
      encounterId: encounterIds,
      patientMasterID:
        patientData?.encounter?.pmasterId ?? selectedBill[0]?.patientMasterID,
      AmountPayed: amountPayed,
      receivedAmount: AllTimeTotalPatShare - amountPayed,
      insAmount,
      insDiscount,
    });
    setBalance(CurrentTotalPatShare);
  }, [selectedBill, patientData]);
  return (
    <Paper elevation={4} className="p-4">
      <div className="flex items-center gap-x-4">
        <Typography
          variant="subtitle1"
          color="textPrimary"
          sx={{ fontWeight: "bold", marginBottom: 1, color: "primary.main" }}
        >
          Amount Details
        </Typography>
        <Button
          onClick={() => setOpen(true)}
          className="bg-primary text-white"
          variant="contained"
          size="small"
          sx={{ marginBottom: 1 }}
        >
          View Billed Items
        </Button>
      </div>

      <Divider sx={{ marginBottom: 2 }} />
      <Grid container spacing={2} sx={{ marginBottom: 2 }}>
        {topDetails.map((item, index) => (
          <Grid item xs={6} key={index}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: "bold",
                  color: "primary.main",
                  flexShrink: 0,
                }}
              >
                {item.label}:
              </Typography>

              <Typography sx={{ fontWeight: 600 }}>
                {Array.isArray(item.value)
                  ? item.value.map((doc, i) => (
                      <div key={i}>
                        {doc}
                        {i === item.value.length - 1 ? "" : ","}
                      </div>
                    ))
                  : item.value}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Divider sx={{ marginBottom: 2 }} />

      <Grid container spacing={2}>
        {details.map((item, index) => (
          <Grid item xs={2} key={index}>
            <Typography
              variant="subtitle2"
              color="textSecondary"
              sx={{ fontWeight: "bold" }}
            >
              {item.label}:{" "}
              <Typography
                component="span"
                sx={{ color: "black", fontWeight: "1000" }}
              >
                {item?.value ?? ""}
              </Typography>
            </Typography>
          </Grid>
        ))}
      </Grid>

      <div className="ml-10">
        <CustomModal title="View Billed Items" open={open} setOpen={setOpen}>
          <Box>
            {
              <DetailsTable
                data={billedDetails?.billingDetails ?? []}
                isLoading={isBillLoading}
              />
            }
          </Box>
        </CustomModal>
      </div>
    </Paper>
  );
};

export default AmountCard;
